export const GET_RENTALS_REQUEST = "GET_RENTALS_REQUEST";
export const GET_RENTALS_SUCCESS = "GET_RENTALS_SUCCESS";
export const GET_RENTALS_FAILURE = "GET_RENTALS_FAILURE";

export const GET_MONTHLY_REQUEST = "GET_MONTHLY_REQUEST";
export const GET_MONTHLY_SUCCESS = "GET_MONTHLY_SUCCESS";
export const GET_MONTHLY_FAILURE = "GET_MONTHLY_FAILURE";
